export default [
  {
    name: 'setting-event',
    path: '/settings/event',
    component: () => import(/* webpackChunkName: "event" */ './Setting.vue'),
    meta: {
      showNavbar: true,
      title: 'Detalhes do evento',
      icon: 'dvr',
      label: 'Configurações gerais',
      roles: ['Admin']
    }
  }
]
